import { getTagFilterDocument } from '@griply/utils';
import Typography from '@mui/material/Typography';
import { useTagById } from 'features/tags';
import { useTasksByFilterDocument } from 'features/tasks';
import React, { useMemo } from 'react';
import { ID } from 'shared/types/id';

import * as Styled from './tag-count.style';

export type TagCountProps = {
  tagId: ID;
};

export const TagCount: React.FC<TagCountProps> = ({ tagId }) => {
  const tag = useTagById(tagId);
  const filterDocument = useMemo(() => getTagFilterDocument(tag), [tag]);
  const tasks = useTasksByFilterDocument(filterDocument);

  return !!tasks.length ? (
    <Styled.Container>
      <Typography variant="overline" component="span">
        {tasks.length}
      </Typography>
    </Styled.Container>
  ) : null;
};
